import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/bootstrap-vue";
import "./plugins/vee-validate";
import Notifications from "vue-notification";
import MemberInfo from "@/components/membership/MemberInfo";
import ShopInfo from "@/components/shop/ShopInfo";
import RoomInfo from "@/components/shop/RoomInfo";
import VueAppleLogin from "vue-apple-login";

import i18n from "./i18n";

import dayJs from "./plugins/dayjs";

import VideoPlayer from "vue-video-player";
import CKEditor from "ckeditor4-vue";
// 구글맵
import * as VueGoogleMaps from "vue2-google-maps";

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(CKEditor);
Vue.use(dayJs);
Vue.use(VideoPlayer);
Vue.use(Notifications);
Vue.component("MemberInfo", MemberInfo);
Vue.component("ShopInfo", ShopInfo);
Vue.component("RoomInfo", RoomInfo);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBAtovuJKbsiCMgWJ11BlgFwIvkNvyPTAs",
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
});

Vue.use(VueAppleLogin, {
  clientId: process.env.VUE_APP_SOCIAL_APPLE_CLIENT_ID,
  scope: "name email",
  redirectURI: "https://krcom.thegolf.com/login",
  state: process.env.VUE_APP_SOCIAL_APPLE_CLIENT_ID,
  usePopup: true,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
